import React, { useContext, useState, useEffect } from 'react'
import emailListContext from '../../../context/context'
import PropTypes from 'prop-types'
import { getPayloadFunction } from '../../Utility'
import { useKeycloak } from '@react-keycloak/web'
import { useHistory } from 'react-router-dom'
import * as emailListService from '../../../Services'
import { renameEmailList } from '../../../Services'

const PublishtoPardot = props => {
    const history = useHistory()
    const { keycloak } = useKeycloak()
    const paramId = (new URLSearchParams(window.location.search)).get('Id')
    const { listType, emailList, setEmailList, searchFields, isListPublished, setIsListPublished, setSnackBar } = useContext(emailListContext)
    const [saveClicked, setSaveClicked] = useState(false)

    useEffect(() => {
        if (saveClicked) {
            handleSave()
        }
    }, [saveClicked])

    const handleSave = async () => {

        const payloadFunction = getPayloadFunction(listType)
        let criteriaPayload = payloadFunction(searchFields)
        const sfUserId = (new URLSearchParams(window.location.search)).get('userid')
        // const isBulkUpload = emailList.polarisEmailListId && emailList.listType && emailList.listType.toLowerCase().includes('bulk') ? true : false

        try {
            if (!emailList.listName) {
                setSaveClicked(false)
                setSnackBar({ type: 'error', message: 'list Name is required!', show: true })
                return
            }

            // if (!isBulkUpload && Object.keys(criteriaPayload).length === 0) {
            //     setSaveClicked(false)
            //     setSnackBar({ type: 'error', message: 'list criteria is required!', show: true })
            //     return
            // }

            const polarisUserId = keycloak.tokenParsed ? keycloak.tokenParsed.sub : ""
            const polarisUserName = keycloak.tokenParsed ? keycloak.tokenParsed.name : "Bulk User"

            const payload = {
                action: 'publishEmailListOfContacts',
                data: {
                    polarisEmailListId: emailList.polarisEmailListId,
                    omniViewSalesForceId: sfUserId,
                    omniViewPardotListId: 'asdasda',
                    emailListOfContactsName: emailList.listName,
                    // polarisUserId: this.state.username,
                    // polarisUserId: keycloak.subject,
                    polarisUserId: `${keycloak.tokenParsed.given_name} ${keycloak.tokenParsed.family_name}`,
                    createdDate: new Date(),
                    modifiedDate: new Date(),
                    omniViewUserId: sfUserId,
                    criteria: JSON.stringify(criteriaPayload),
                    emailListActionType: 'Publish',
                    addedContacts: searchFields.addedContacts,
                    deletedContacts: searchFields.deletedContacts,
                    recordStatus: "Published",
                    subjectPropertyCriteria: JSON.stringify(searchFields.SubjectProperty),
                    mergeListIds: JSON.stringify(searchFields.SelectedLists),
                }
            }
            // this.setState({ showSpinner: true });
            const response = await emailListService.publishEmailList(payload)
            await renameEmailList({ "polarisEmailListId": emailList.polarisEmailListId, recordStatus: 'Published', polarisUserId, polarisUserName })
            // this.setState({ showSpinner: false });
            // console.log('response:::', response)
            var totalnumber = 0
            if (response.status === 200) {
                setSnackBar({ type: 'success', message: 'List published !!', show: true })
                setIsListPublished(true)
                setSaveClicked(false)
                let newEmailList = { ...emailList }
                newEmailList.recordStatus === 'Published'
                setEmailList(newEmailList)

                const pathName = (window.location.href).includes('EmailListDetails') ? '/EmailListDetails' : '/EmailLists'
                history.push({
                    pathname: pathName,
                    search: "?" + new URLSearchParams({ listType: 'property', Id: emailList.polarisEmailListId, Name: emailList.listName, total: totalnumber }).toString()
                })
                // if (pathName === '/EmailLists') {
                //     this.props.setIsPublished(true)
                // }
                // setTimeout(() => this.setState({ alertStatus: alertStatus.none }), 3000)
            }
            // else {
            //     setSaveClicked(false)
            //     setSnackBar({ type: 'error', message: 'Unable to publish the list. ', show: true })
            // }
            // this.setState({ isLoading: false })
        } catch (err) {
            // this.setState({ showSpinner: false });
            setSaveClicked(false)
            console.log('err::', err)
            setSnackBar({ type: 'error', message: 'Unable to publish the list. ', show: true })
        }

    }

    const isdisabled = () => {
        let returnVal = false
        if (!emailList.polarisEmailListId || isListPublished) {
            returnVal = true
        }

        return returnVal
    }

    return (
        <>
            {saveClicked ?
                <button className="btn btn-primary c-disabled">
                    <span className="loader h-5 w-5 mx-2" ></span>
                    <span className="px-2">Publish to Pardot</span>
                </button>
                :
                <button data-testid="TopMenu_btnPublish_test" disabled={isdisabled()} className={props.className} onClick={() => { setSaveClicked(true) }}>
                    Publish to Pardot
                </button>
            }

        </>
    )
}

PublishtoPardot.propTypes = {
    className: PropTypes.string
}

export default PublishtoPardot
